(function () {
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeId(value) {
    return String(value || '').trim().replace(/^"+|"+$/g, '');
  }

  function normalizeLinkedItems(list) {
    if (!Array.isArray(list)) return [];

    return list
      .map(function (item) {
        return {
          id: normalizeId(item && item.id),
          title: item && item.title ? item.title : '',
          url: item && item.url ? item.url : ''
        };
      })
      .filter(function (item) {
        return !!item.id;
      });
  }

  function initPhotoSection(section) {
    if (!section || section.dataset.photoInited === 'true') return;

    var exploreText = section.dataset.exploreText || 'Explore';
    var prevText = section.dataset.prevText || 'Previous';
    var nextText = section.dataset.nextText || 'Next';
    var emptyText = section.dataset.emptyText || 'No images found.';
    var downloadText = section.dataset.downloadText || 'Download JPG';

    section.dataset.photoInited = 'true';

    var sectionId = section.id ? section.id.replace('PhotoSection-', '') : '';

    var photosDataEl = document.getElementById('photo-data-photos-' + sectionId);
    var camerasDataEl = document.getElementById('photo-data-cameras-' + sectionId);
    var lensesDataEl = document.getElementById('photo-data-lenses-' + sectionId);

    async function forceDownloadFile(url, fileName) {
      if (!url) return;

      try {
        var response = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error('Download request failed');

        var blob = await response.blob();
        var blobUrl = window.URL.createObjectURL(blob);

        var tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = fileName || 'photo.jpg';
        document.body.appendChild(tempLink);
        tempLink.click();
        tempLink.remove();

        setTimeout(function () {
          window.URL.revokeObjectURL(blobUrl);
        }, 1000);
      } catch (error) {
        var fallbackLink = document.createElement('a');
        fallbackLink.href = url;
        fallbackLink.download = fileName || 'photo.jpg';
        fallbackLink.rel = 'noopener';
        document.body.appendChild(fallbackLink);
        fallbackLink.click();
        fallbackLink.remove();
      }
    }

    if (!photosDataEl || !camerasDataEl || !lensesDataEl) return;

    var photos = JSON.parse(photosDataEl.textContent || '[]').map(function (item) {
      return {
        name: item.name || '',
        author: item.author || '',
        thumb: item.thumb || item.photo || '',
        photo: item.thumb || item.photo || '',
        full: item.full || item.download || item.photo || '',
        download: item.download || item.full || item.photo || '',
        camera: normalizeLinkedItems(item.camera),
        lens: normalizeLinkedItems(item.lens)
      };
    });

    var cameras = JSON.parse(camerasDataEl.textContent || '[]').map(function (item) {
      return {
        id: normalizeId(item.id),
        title: item.title || '',
        image: item.image || '',
        desc: item.desc || '',
        url: item.url || ''
      };
    });

    var lenses = JSON.parse(lensesDataEl.textContent || '[]').map(function (item) {
      return {
        id: normalizeId(item.id),
        title: item.title || '',
        image: item.image || '',
        desc: item.desc || '',
        url: item.url || ''
      };
    });

    var galleryEl = section.querySelector('.photo-gallery');
    var emptyEl = section.querySelector('.photo-empty');
    var gearInfoEl = section.querySelector('.photo-gear-info');

    if (emptyEl) {
      emptyEl.textContent = emptyText;
    }

    var paginationWrap = section.querySelector('.photo-pagination');
    if (!paginationWrap && galleryEl) {
      paginationWrap = document.createElement('div');
      paginationWrap.className = 'photo-pagination hidden';
      galleryEl.insertAdjacentElement('afterend', paginationWrap);
    }

    var cameraButtons = Array.from(section.querySelectorAll('[data-filter-type="camera"]'));
    var lensButtons = Array.from(section.querySelectorAll('[data-filter-type="lens"]'));

    cameraButtons.forEach(function (btn) {
      btn.dataset.filterId = normalizeId(btn.dataset.filterId);
      if (btn.tagName === 'BUTTON' && !btn.getAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
    });

    lensButtons.forEach(function (btn) {
      btn.dataset.filterId = normalizeId(btn.dataset.filterId);
      if (btn.tagName === 'BUTTON' && !btn.getAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
    });

    var modal = section.querySelector('.photo-modal');
    var modalMedia = section.querySelector('.photo-modal__media');
    var modalImage = section.querySelector('[id^="PhotoModalImage-"]');
    var modalTitle = section.querySelector('[id^="PhotoModalTitle-"]');
    var modalAuthor = section.querySelector('[id^="PhotoModalAuthor-"]');
    var modalGear = section.querySelector('[id^="PhotoModalGear-"]');
    var modalDownload = section.querySelector('[id^="PhotoModalDownload-"]');
    var modalPrev = section.querySelector('[id^="PhotoModalPrev-"]');
    var modalNext = section.querySelector('[id^="PhotoModalNext-"]');

    if (modalDownload) {
      modalDownload.textContent = downloadText;
    }

    var state = {
      selectedCamera: cameraButtons[0] ? normalizeId(cameraButtons[0].dataset.filterId) : null,
      selectedLens: lensButtons[0] ? normalizeId(lensButtons[0].dataset.filterId) : null,
      filteredPhotos: [],
      pagedPhotos: [],
      currentIndex: 0,
      currentPage: 1,
      totalPages: 1,
      perPage: getPerPage()
    };

    var isModalAnimating = false;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchCurrentX = 0;
    var touchCurrentY = 0;
    var isSwiping = false;

    function getPerPage() {
      if (window.innerWidth <= 575) return 5;
      if (window.innerWidth <= 1200) return 8;
      return 9;
    }

    function isStackLayout() {
      return window.innerWidth <= 1200;
    }

    function isSideBySideLayout() {
      return window.innerWidth > 1200;
    }

    function isSwipeLayout() {
      return window.innerWidth <= 1200;
    }

    function getCameraById(id) {
      id = normalizeId(id);
      return cameras.find(function (item) {
        return item.id === id;
      }) || null;
    }

    function getLensById(id) {
      id = normalizeId(id);
      return lenses.find(function (item) {
        return item.id === id;
      }) || null;
    }

    function photoHasCamera(photo, cameraId) {
      cameraId = normalizeId(cameraId);
      if (!cameraId) return true;

      return Array.isArray(photo.camera) && photo.camera.some(function (item) {
        return normalizeId(item.id) === cameraId;
      });
    }

    function photoHasLens(photo, lensId) {
      lensId = normalizeId(lensId);
      if (!lensId) return true;

      return Array.isArray(photo.lens) && photo.lens.some(function (item) {
        return normalizeId(item.id) === lensId;
      });
    }

    function setActiveButtons() {
      cameraButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', normalizeId(btn.dataset.filterId) === state.selectedCamera);
      });

      lensButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', normalizeId(btn.dataset.filterId) === state.selectedLens);
      });
    }

    function renderGearInfo() {
      if (!gearInfoEl) return;

      var html = '';
      var camera = state.selectedCamera ? getCameraById(state.selectedCamera) : null;
      var lens = state.selectedLens ? getLensById(state.selectedLens) : null;

      function renderCard(item) {
        return (
          '<div class="photo-gear-card">' +
            '<div class="photo-gear-card__image">' +
              (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">' : '') +
            '</div>' +
            '<div class="photo-gear-card__content">' +
              '<h3 class="photo-gear-card__title">' + escapeHtml(item.title) + '</h3>' +
              (item.desc ? '<div class="photo-gear-card__desc">' + escapeHtml(item.desc) + '</div>' : '') +
              (item.url ? '<a class="photo-gear-card__link" href="' + item.url + '">' + escapeHtml(exploreText) + ' ' + escapeHtml(item.title) + ' ></a>' : '') +
            '</div>' +
          '</div>'
        );
      }

      if (camera) html += renderCard(camera);
      if (lens) html += renderCard(lens);

      gearInfoEl.innerHTML = html;
    }

    function getFilteredPhotos() {
      return photos.filter(function (item) {
        var matchCamera = state.selectedCamera ? photoHasCamera(item, state.selectedCamera) : true;
        var matchLens = state.selectedLens ? photoHasLens(item, state.selectedLens) : true;
        return matchCamera && matchLens;
      });
    }

    function updateGalleryLayoutClass() {
      if (!galleryEl) return;
      var isSingleColumn = window.innerWidth <= 575;
      galleryEl.classList.toggle('is-single-column', isSingleColumn);
      galleryEl.classList.toggle('is-multi-column', !isSingleColumn);
    }

    function paginatePhotos() {
      state.perPage = getPerPage();
      state.totalPages = Math.max(1, Math.ceil(state.filteredPhotos.length / state.perPage));

      if (state.currentPage > state.totalPages) {
        state.currentPage = state.totalPages;
      }
      if (state.currentPage < 1) {
        state.currentPage = 1;
      }

      var start = (state.currentPage - 1) * state.perPage;
      var end = start + state.perPage;
      state.pagedPhotos = state.filteredPhotos.slice(start, end);
    }

    function renderPagination() {
      if (!paginationWrap) return;

      if (!state.filteredPhotos.length || state.totalPages <= 1) {
        paginationWrap.classList.add('hidden');
        paginationWrap.innerHTML = '';
        return;
      }

      paginationWrap.classList.remove('hidden');

      var pageNumbersHtml = '';
      for (var i = 1; i <= state.totalPages; i++) {
        pageNumbersHtml +=
          '<button type="button" class="photo-pagination__page' + (i === state.currentPage ? ' is-active' : '') + '" data-page="' + i + '">' +
            i +
          '</button>';
      }

      paginationWrap.innerHTML =
        '<div class="photo-pagination__inner">' +
          '<button type="button" class="photo-pagination__prev' + (state.currentPage === 1 ? ' is-disabled' : '') + '" data-page-action="prev"' + (state.currentPage === 1 ? ' disabled' : '') + '>' +
            '<span class="photo-pagination__arrow">‹</span><span class="photo-pagination__text">' + escapeHtml(prevText) + '</span>' +
          '</button>' +
          '<div class="photo-pagination__pages">' + pageNumbersHtml + '</div>' +
          '<button type="button" class="photo-pagination__next' + (state.currentPage === state.totalPages ? ' is-disabled' : '') + '" data-page-action="next"' + (state.currentPage === state.totalPages ? ' disabled' : '') + '>' +
            '<span class="photo-pagination__text">' + escapeHtml(nextText) + '</span><span class="photo-pagination__arrow">›</span>' +
          '</button>' +
        '</div>';

      var prevBtn = paginationWrap.querySelector('[data-page-action="prev"]');
      var nextBtn = paginationWrap.querySelector('[data-page-action="next"]');
      var pageBtns = paginationWrap.querySelectorAll('[data-page]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (state.currentPage <= 1) return;
          state.currentPage -= 1;
          renderGalleryPage(true);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (state.currentPage >= state.totalPages) return;
          state.currentPage += 1;
          renderGalleryPage(true);
        });
      }

      pageBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetPage = Number(btn.dataset.page || 1);
          if (targetPage === state.currentPage) return;
          state.currentPage = targetPage;
          renderGalleryPage(true);
        });
      });
    }

    function bindCardClickEvents() {
      if (!galleryEl) return;

      galleryEl.querySelectorAll('.photo-card').forEach(function (card) {
        card.addEventListener('click', function () {
          state.currentIndex = Number(card.dataset.photoIndex || 0);
          openModal();
        });
      });
    }

    function renderGalleryPage(keepViewportTop) {
      if (!galleryEl) return;

      updateGalleryLayoutClass();
      paginatePhotos();

      if (!state.filteredPhotos.length) {
        galleryEl.innerHTML = '';
        if (paginationWrap) paginationWrap.classList.add('hidden');
        if (emptyEl) emptyEl.classList.remove('hidden');
        return;
      }

      if (emptyEl) emptyEl.classList.add('hidden');

      var start = (state.currentPage - 1) * state.perPage;

      galleryEl.innerHTML = state.pagedPhotos.map(function (item, index) {
        var globalIndex = start + index;

        return (
          '<article class="photo-card" data-photo-index="' + globalIndex + '">' +
            '<div class="photo-card__image">' +
              '<img src="' + (item.thumb || item.photo) + '" alt="' + escapeHtml(item.name) + '" loading="lazy">' +
            '</div>' +
            '<div class="photo-card__meta">' +
              '<p class="photo-card__author">© ' + escapeHtml(item.author) + '</p>' +
            '</div>' +
          '</article>'
        );
      }).join('');

      bindCardClickEvents();
      renderPagination();

      if (keepViewportTop) {
        requestAnimationFrame(function () {
          galleryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function renderGallery(resetPage) {
      state.filteredPhotos = getFilteredPhotos();

      if (resetPage) {
        state.currentPage = 1;
      }

      state.currentIndex = 0;
      renderGalleryPage(false);
    }

    function getModalPhotos() {
      return state.filteredPhotos || [];
    }

    function syncModalNavVisibility() {
      var modalPhotos = getModalPhotos();
      var many = modalPhotos.length > 1;
      var showDesktopNav = many && isSideBySideLayout();

      if (modal) {
        modal.classList.toggle('is-stack-layout', isStackLayout());
        modal.classList.toggle('is-side-layout', isSideBySideLayout());
      }

      if (modalPrev) {
        modalPrev.style.display = showDesktopNav ? 'block' : 'none';
      }

      if (modalNext) {
        modalNext.style.display = showDesktopNav ? 'block' : 'none';
      }
    }

    function renderModalLinkedRows(items) {
      if (!Array.isArray(items) || !items.length) return '';

      return items.map(function (item) {
        if (item.url) {
          return '<div class="photo-modal__gear-row"><a class="photo-modal__gear-link" href="' + item.url + '">' + escapeHtml(exploreText) + ' ' + escapeHtml(item.title) + ' ></a></div>';
        }

        return '<div class="photo-modal__gear-row">' + escapeHtml(item.title) + '</div>';
      }).join('');
    }

    function setModalImageContent() {
      var modalPhotos = getModalPhotos();
      var item = modalPhotos[state.currentIndex];
      if (!item || !modal) return;

      if (modalImage) {
        modalImage.src = item.full || item.download || item.photo;
        modalImage.alt = item.name || '';
      }

      if (modalAuthor) modalAuthor.textContent = item.author ? '© ' + item.author : '';

      if (modalGear) {
        var gearHtml = '';
        gearHtml += renderModalLinkedRows(item.camera);
        gearHtml += renderModalLinkedRows(item.lens);
        modalGear.innerHTML = gearHtml;
      }

      if (modalDownload) {
        var downloadUrl = item.download || item.full || item.photo || '';
        var fileName = (item.name || 'photo')
          .replace(/[\\/:*?"<>|]+/g, '-')
          .replace(/\s+/g, ' ')
          .trim() || 'photo';

        modalDownload.href = downloadUrl;
        modalDownload.textContent = downloadText;
        modalDownload.setAttribute('download', fileName + '.jpg');
        modalDownload.setAttribute('data-download-url', downloadUrl);
        modalDownload.setAttribute('data-download-name', fileName + '.jpg');
      }

      syncModalNavVisibility();
    }

    function updateModal() {
      setModalImageContent();
    }

    function clearAnimationClasses() {
      if (!modalMedia) return;
      modalMedia.classList.remove('is-animating', 'is-next-out', 'is-next-in', 'is-prev-out', 'is-prev-in');
    }

    function animateModalChange(direction) {
      if (!modalMedia || !modalImage || isModalAnimating) {
        updateModal();
        return;
      }

      isModalAnimating = true;

      var outClass = direction === 'next' ? 'is-next-out' : 'is-prev-out';
      var inClass = direction === 'next' ? 'is-next-in' : 'is-prev-in';

      clearAnimationClasses();
      modalMedia.classList.add('is-animating');

      requestAnimationFrame(function () {
        modalMedia.classList.add(outClass);

        setTimeout(function () {
          modalMedia.classList.remove(outClass);

          setModalImageContent();

          modalMedia.classList.add(inClass);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              modalMedia.classList.remove(inClass);

              setTimeout(function () {
                clearAnimationClasses();
                isModalAnimating = false;
              }, 350);
            });
          });
        }, 350);
      });
    }

    function openModal() {
      if (!modal) return;
      clearAnimationClasses();
      isModalAnimating = false;
      updateModal();
      modal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
      syncModalNavVisibility();
    }

    function closeModal() {
      if (!modal) return;
      clearAnimationClasses();
      isModalAnimating = false;
      modal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }

    function prevPhoto() {
      var modalPhotos = getModalPhotos();
      if (!modalPhotos.length || isModalAnimating) return;
      state.currentIndex = (state.currentIndex - 1 + modalPhotos.length) % modalPhotos.length;
      animateModalChange('prev');
    }

    function nextPhoto() {
      var modalPhotos = getModalPhotos();
      if (!modalPhotos.length || isModalAnimating) return;
      state.currentIndex = (state.currentIndex + 1) % modalPhotos.length;
      animateModalChange('next');
    }

    function applyFiltersAndKeepScroll() {
      setActiveButtons();
      renderGearInfo();
      renderGallery(true);
    }

    cameraButtons.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var id = normalizeId(btn.dataset.filterId);

        if (state.selectedCamera === id) {
          state.selectedCamera = null;
        } else {
          state.selectedCamera = id;
        }

        applyFiltersAndKeepScroll();
      });
    });

    lensButtons.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var id = normalizeId(btn.dataset.filterId);

        if (state.selectedLens === id) {
          state.selectedLens = null;
        } else {
          state.selectedLens = id;
        }

        applyFiltersAndKeepScroll();
      });
    });

    section.querySelectorAll('[data-photo-close]').forEach(function (el) {
      el.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeModal();
      });
    });

    if (modalPrev) {
      modalPrev.addEventListener('click', function (evt) {
        evt.preventDefault();
        prevPhoto();
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', function (evt) {
        evt.preventDefault();
        nextPhoto();
      });
    }

    if (modalDownload) {
      modalDownload.addEventListener('click', function (evt) {
        evt.preventDefault();

        var downloadUrl = modalDownload.getAttribute('data-download-url') || modalDownload.href || '';
        var downloadName = modalDownload.getAttribute('data-download-name') || 'photo.jpg';

        forceDownloadFile(downloadUrl, downloadName);
      });
    }

    document.addEventListener('keydown', function (evt) {
      if (!modal || modal.classList.contains('hidden')) return;
      if (evt.key === 'Escape') closeModal();
      if (evt.key === 'ArrowLeft') prevPhoto();
      if (evt.key === 'ArrowRight') nextPhoto();
    });

    if (modalMedia) {
      modalMedia.addEventListener('touchstart', function (evt) {
        if (!modal || modal.classList.contains('hidden')) return;
        if (!isSwipeLayout()) return;
        if (!evt.touches || !evt.touches.length) return;

        touchStartX = evt.touches[0].clientX;
        touchStartY = evt.touches[0].clientY;
        touchCurrentX = touchStartX;
        touchCurrentY = touchStartY;
        isSwiping = true;
      }, { passive: true });

      modalMedia.addEventListener('touchmove', function (evt) {
        if (!isSwiping) return;
        if (!modal || modal.classList.contains('hidden')) return;
        if (!isSwipeLayout()) return;
        if (!evt.touches || !evt.touches.length) return;

        touchCurrentX = evt.touches[0].clientX;
        touchCurrentY = evt.touches[0].clientY;
      }, { passive: true });

      modalMedia.addEventListener('touchend', function () {
        if (!isSwiping) return;
        isSwiping = false;

        if (!modal || modal.classList.contains('hidden')) return;
        if (!isSwipeLayout()) return;
        if (isModalAnimating) return;

        var diffX = touchCurrentX - touchStartX;
        var diffY = touchCurrentY - touchStartY;

        if (Math.abs(diffX) < 50) return;
        if (Math.abs(diffX) <= Math.abs(diffY)) return;

        if (diffX < 0) {
          nextPhoto();
        } else {
          prevPhoto();
        }
      }, { passive: true });

      modalMedia.addEventListener('touchcancel', function () {
        isSwiping = false;
      }, { passive: true });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var oldPerPage = state.perPage;
        var newPerPage = getPerPage();

        updateGalleryLayoutClass();

        if (oldPerPage !== newPerPage) {
          state.perPage = newPerPage;
          state.currentPage = 1;
          renderGallery(false);
        } else {
          renderGalleryPage(false);
        }

        if (modal && !modal.classList.contains('hidden')) {
          syncModalNavVisibility();
        }
      }, 120);
    });

    setActiveButtons();
    renderGearInfo();
    renderGallery(true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.photo-page').forEach(initPhotoSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container) return;
    var section = container.querySelector('.photo-page') || container.closest('.photo-page');
    if (section) initPhotoSection(section);
  });
})();